import { useQuery } from '@tanstack/react-query';
import { strapiFetchParameterUjisByDocumentIds } from '../../api/strapiCrm';
import { queryKeys } from '../queryKeys';

export function useParameterUjisByDocumentIdsQuery(jwt: string | null, documentIds: string[]) {
  const sortedKey = [...new Set(documentIds.map((x) => x.trim()).filter(Boolean))].sort().join('|');

  return useQuery({
    queryKey: queryKeys.parameterUjisByDocumentIdsPack(jwt, sortedKey),
    queryFn: () =>
      strapiFetchParameterUjisByDocumentIds(
        jwt!,
        sortedKey.length > 0 ? sortedKey.split('|').filter(Boolean) : [],
      ),
    enabled: Boolean(jwt && sortedKey.length > 0),
    staleTime: 60_000,
  });
}
